export default __webpack_public_path__ + "static/media/list.fcf6e659.svg";